// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'input', selector: '.form-control' })
  onInputFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }
}
